module.exports = __webpack_public_path__ + "static/img/icon_s11.4d98867.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_s11.png
// module id = 036K
// module chunks = 21